module.exports = __webpack_public_path__ + "static/media/template_s10.ecde4e95.jpg";